import(/* webpackMode: "eager", webpackExports: ["About"] */ "/app/next/src/components/pages/About/About.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
